import { ServerTimeHelper, translate } from "@mediaspace/shared/utils";
import AddToCalendarContainer from "./AddToCalendarContainer";
import { KmsTypeMediaSchedulingData } from "@mediaspace/shared/types";
import { KmsTypeComponent } from "@mediaspace/shared/types/KmsTypeComponent";
import { KalturaBaseEntry } from "kaltura-typescript-client/api/types";

/**
 * get media status to pass from hero component to lobby component
 */
const getStatusLabel = (schedulingData?: KmsTypeMediaSchedulingData): string => {
    const isScheduled = !!schedulingData?.from && !!schedulingData?.to;
    const isSessionEnded =
        !!schedulingData?.to &&
        ServerTimeHelper.getUpdatedTime() > schedulingData?.to;

    let statusLabel = "";

    if (isScheduled) {
        if (isSessionEnded) {
            statusLabel = translate("Session Ended");
        } else {
            statusLabel = translate("This Session will start soon");
        }
    }

    return statusLabel;
};

/**
 * get actions to pass from hero component to lobby component
 */
const getActions = (
    entryId: string,
    schedulingData?: KmsTypeMediaSchedulingData,
    actions?: KmsTypeComponent[],
) => {
    let actionsToShow: KmsTypeComponent[] = [];

    if (
        schedulingData &&
        ServerTimeHelper.getUpdatedTime() < schedulingData.to
    ) {
        actionsToShow = [
            {
                name: "calendar",
                component: AddToCalendarContainer,
                props: {
                    entryId: entryId,
                },
            },
        ];
    }
    return [...actionsToShow, ...actions].filter(action => action);
};

/**
 * single function for getting all props to pass from hero components to lobby component
 */
export const getPropsToPass = (
    entry: KalturaBaseEntry,
    schedulingData?: KmsTypeMediaSchedulingData,
    actions?: KmsTypeComponent[],
) => {
    const statusLabel = getStatusLabel(schedulingData);
    const actionsToPass = getActions(entry.id, schedulingData, actions);
    return { statusLabel, actionsToPass };
};

/**
 * hook for getting correct thumbnail size
 */
export const useThumbnailSizing = (thumbnailUrl: string) => thumbnailUrl + "/width/1600/height/900/type/3";
